import { Component } from '@angular/core'
import { ContentLayoutComponent } from '../content-layout.component'
import { RouterLink } from '@angular/router';
import { NgClass, NgIf, AsyncPipe } from '@angular/common';
import { BadgeModule } from 'primeng/badge';

@Component({
    selector: 'app-topbar',
    templateUrl: './content-topbar.component.html',
    styleUrls: ['./content-topbar.component.scss'],
    standalone: true,
    imports: [
        RouterLink,
        NgClass,
        NgIf,
        BadgeModule,
        AsyncPipe,
    ],
})
export class ContentTopbarComponent {
  hasMessages: Boolean

  constructor(public contentLayout: ContentLayoutComponent) {}
}
